import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { TitleStyled } from './styles/TitleStyled';

const Title = ({
  tag,
  children,
  color,
  size,
  type,
  font,
  getRef,
  className,
  fixedSize,
  weight,
  ...props
}) => (
  <TitleStyled
    {...props}
    ref={getRef}
    className={className}
    color={color}
    size={size}
    type={type}
    font={font}
    fixedSize={fixedSize}
    weight={weight}
    as={tag}
  >
    {children}
  </TitleStyled>
);

Title.propTypes = {
  tag: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  type: PropTypes.string,
  font: PropTypes.string,
  children: PropTypes.string,
  getRef: PropTypes.func,
  className: PropTypes.string,
  fixedSize: PropTypes.bool,
  weight: PropTypes.string,
};

Title.defaultProps = {
  tag: 'h3',
  size: '',
  color: '',
  type: '',
  font: '',
  children: '',
  className: '',
  getRef: Function.prototype,
  fixedSize: false,
  weight: '',
};

export default memo(Title);
